var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocalHospital = function SvgLocalHospital(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.875 17.025h2.25v-3.9h3.9v-2.25h-3.9v-3.9h-2.25v3.9h-3.9v2.25h3.9zM4.5 21q-.6 0-1.05-.45T3 19.5v-15q0-.6.45-1.05T4.5 3h15q.6 0 1.05.45T21 4.5v15q0 .6-.45 1.05T19.5 21zm0-1.5h15v-15h-15z"
  })));
};
export default SvgLocalHospital;